import { useStepper } from "@vueuse/core";
/**
 * Composable for creating a wizard with multiple steps.
 *
 * This is a thin wrapper around `useStepper` that provides a more specific type.
 * @param steps The steps of the wizard.
 * @param initialStep The initial step to start the wizard on.
 * @returns A stepper object for the wizard.
 */
export function useWizard(steps, initialStep) {
    return useStepper(steps, initialStep);
}
